import { TechTuningCategory } from '~/shared';
import { ColorGradient } from '../ItemColor/ItemColor.model';

const colorOrder = [
	ColorGradient.Red,
	ColorGradient.Gold,
	ColorGradient.Green,
	ColorGradient.Purple,
	ColorGradient.Blue,
];

const categoryOrder = [
	TechTuningCategory.ENGINE,
	TechTuningCategory.EXHAUST,
	TechTuningCategory.RADIATOR,
	TechTuningCategory.STARTER,
	TechTuningCategory.SUSPENSION,
	TechTuningCategory.TURBO,
	TechTuningCategory.BRAKES,
	TechTuningCategory.TIRES,
];

export const items = colorOrder.flatMap((color, colorIndex) =>
	categoryOrder.map((category, categoryIndex) => ({
		id: colorIndex * categoryOrder.length + categoryIndex,
		category,
		imageBg: color,
	})),
);

export const sortItemsByColorAndCategory = <
	T extends {
		category: TechTuningCategory | undefined;
		imageBg?: ColorGradient;
	},
>(
	items: T[],
): T[] => {
	return items.sort((a, b) => {
		const colorA = a.imageBg || ColorGradient.Blue;
		const colorB = b.imageBg || ColorGradient.Blue;
		const colorIndexA = colorOrder.indexOf(colorA);
		const colorIndexB = colorOrder.indexOf(colorB);

		if (colorIndexA !== colorIndexB) {
			return colorIndexA - colorIndexB;
		}

		const categoryIndexA = categoryOrder.indexOf(
			a.category ?? TechTuningCategory.ENGINE,
		);
		const categoryIndexB = categoryOrder.indexOf(
			b.category ?? TechTuningCategory.ENGINE,
		);

		return categoryIndexA - categoryIndexB;
	});
};
